// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 334 ? "5e0221ee" : chunkId) + "." + {"238":"a49c9752c99f2ac1","334":"244ee815195da2c1"}[chunkId] + ".js";
};